import { ReactElement } from 'react'
import ReactDOMServer from 'react-dom/server'

const convertJsxToPlainText = (node: ReactElement) => {
    const html = ReactDOMServer.renderToStaticMarkup(node)

    return html
        .replace(/<[^>]+>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
}

export default convertJsxToPlainText
